(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers-collection-slider"] && !Shopify.designMode) return;
  try {
    
  const initBestsellersProgress = (section) => {
    if (!section || section.dataset.bestsellersInit === 'true') return;

    const scroller = section.querySelector('slideshow-slides');
    const progress = section.querySelector('[data-bestsellers-progress]');
    if (!scroller || !progress) return;

    const updateProgressState = () => {
      const maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
      const currentScroll = Math.min(scroller.scrollLeft, maxScroll);
      const trackWidth = progress.clientWidth;
      const visibleRatio = scroller.scrollWidth > 0
        ? scroller.clientWidth / scroller.scrollWidth
        : 1;
      const thumbWidth = Math.max(40, Math.round(trackWidth * visibleRatio));

      progress.max = String(maxScroll > 0 ? maxScroll : 1);
      progress.value = String(currentScroll);
      progress.disabled = maxScroll <= 0;
      section.style.setProperty('--progress-thumb-width', `${thumbWidth}px`);
    };

    // Usar IntersectionObserver para detectar cuando el último item es visible
    const allItems = scroller?.querySelectorAll('.resource-list__item');
    const lastItem = allItems && allItems.length > 0 ? allItems[allItems.length - 1] : null;
    if (lastItem) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            section.classList.toggle('is-at-end', entry.isIntersecting);
          });
        },
        { root: scroller, threshold: 0.1 }
      );
      io.observe(lastItem);
    }

    let rafId;
    const syncFromScroll = () => {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(() => {
        const maxScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
        progress.value = String(Math.min(scroller.scrollLeft, maxScroll));
      });
    };

    progress.addEventListener('input', () => {
      scroller.scrollTo({ left: Number(progress.value), behavior: 'auto' });
    });

    scroller.addEventListener('scroll', syncFromScroll, { passive: true });

    const resizeObserver = new ResizeObserver(updateProgressState);
    resizeObserver.observe(scroller);
    resizeObserver.observe(progress);

    updateProgressState();
    section.dataset.bestsellersInit = 'true';
  };

  const disableCardHoverJS = (section) => {
    const kill = () => {
      section.querySelectorAll('product-card').forEach((card) => {
        card.previewImage = () => {};
        card.resetImage = () => {};
      });
    };
    kill();
    customElements.whenDefined('product-card').then(kill);
    requestAnimationFrame(kill);
    setTimeout(kill, 500);
    setTimeout(kill, 1500);
  };

  const initProductRecommendations = (section) => {
    if (!section || section.dataset.recsInit === 'true') return;
    const url = section.dataset.productRecsUrl;
    const state = section.dataset.productRecsState;
    if (!url || state !== 'initial') return;
    section.dataset.recsInit = 'true';

    const load = () => {
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('.bestsellers-slider-section');
          if (!fresh) return;
          if (fresh.hasAttribute('hidden')) {
            const bg = section.previousElementSibling;
            if (bg && bg.classList.contains('section-background')) bg.remove();
            section.replaceWith(fresh);
            return;
          }
          section.replaceWith(fresh);
          initBestsellersProgress(fresh);
          disableCardHoverJS(fresh);
        })
        .catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              io.unobserve(e.target);
              load();
            }
          });
        },
        { rootMargin: '400px' }
      );
      io.observe(section);
    } else {
      load();
    }
  };

  const initAllBestsellersSliders = (root = document) => {
    root.querySelectorAll('.bestsellers-slider-section').forEach((section) => {
      initProductRecommendations(section);
      initBestsellersProgress(section);
      disableCardHoverJS(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAllBestsellersSliders());
  document.addEventListener('shopify:section:load', (event) => initAllBestsellersSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp"]) return;
  try {
    
  (function () {
    const initCustomPDP = (section) => {
      const form = section.querySelector('#custom-pdp-form');
      if (!form) return;

      const variantIdInput = form.querySelector('[data-variant-id]');
      const radios = form.querySelectorAll('input[type="radio"]');
      const qtyInput = form.querySelector('[data-qty-input]');
      const qtyMinus = form.querySelector('[data-qty-minus]');
      const qtyPlus = form.querySelector('[data-qty-plus]');

      const getCurrentQty = () => Math.max(1, parseInt(qtyInput?.value, 10) || 1);

      // Holds the currently selected variant so price recomputes use the right unit.
      // Reassigned by updateUI() whenever the user picks a different variant.
      let selectedVariant = null;

      // Cup options are variant-backed (each 1/2/4 button selects the matching pack
      // variant at quantity 1), so the price is simply the selected variant's price.
      // The qty-selector path (products ≥ €100) multiplies by the chosen quantity.
      const refreshPriceForQty = () => {
        if (!selectedVariant) return;
        const qty = getCurrentQty();
        const total = (selectedVariant.price || 0) * qty;
        const priceEl = section.querySelector('.custom-pdp__price');
        const stickyPriceEl = section.querySelector('[data-sticky-price]');
        const formatted = formatPriceSafe(total);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPriceEl) stickyPriceEl.textContent = formatted;

        // Fake Klarna: monthly = total / 3 (recomputes with both variant and quantity)
        const installmentsEl = section.querySelector('[data-installments-monthly]');
        if (installmentsEl) {
          installmentsEl.textContent = formatPriceSafe(Math.floor(total / 3));
        }
      };

      const formatPriceSafe = (price) => {
        // Whole euros, no decimals (matches the storefront's money format, e.g. "145 €").
        return Math.round((price || 0) / 100).toLocaleString('es-ES') + ' €';
      };

      if (qtyMinus && qtyPlus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          const val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
          refreshPriceForQty();
        });
        qtyPlus.addEventListener('click', () => {
          const val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
          refreshPriceForQty();
        });
        qtyInput.addEventListener('change', () => {
          const val = parseInt(qtyInput.value, 10);
          if (!val || val < 1) qtyInput.value = 1;
          refreshPriceForQty();
        });
        qtyInput.addEventListener('input', refreshPriceForQty);
      }

      // Cup quantity buttons (replaces qty selector for products under €100).
      // Clicking 1/2/4 CUP crossfades the first gallery image to the override
      // configured by the merchant. The override is rendered on a stacked
      // overlay <img> so the original image stays untouched and 1 CUP just
      // hides the overlay (instant return, no reload).
      const cupBtns = form.querySelectorAll('[data-cup-qty]');
      const firstMediaItem = section.querySelector('.custom-pdp__media-item');

      let cupOverlayImg = null;
      if (firstMediaItem && cupBtns.length) {
        cupOverlayImg = document.createElement('img');
        cupOverlayImg.className = 'custom-pdp__cup-overlay-img';
        cupOverlayImg.alt = '';
        cupOverlayImg.decoding = 'async';
        cupOverlayImg.setAttribute('aria-hidden', 'true');
        firstMediaItem.appendChild(cupOverlayImg);

        // Preload override images so the crossfade is instant
        cupBtns.forEach((btn) => {
          const url = btn.dataset.cupImage;
          if (url) {
            const pre = new Image();
            pre.decoding = 'async';
            pre.src = url;
          }
        });
      }

      if (cupBtns.length && qtyInput) {
        cupBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const qty = parseInt(btn.dataset.cupQty, 10) || 1;
            // Variant-backed: each cup option maps to the real "N Cup" pack variant,
            // so the displayed price and the price charged at checkout both come from
            // that variant (qty 1). Fall back to qty-multiplication if no pack variant.
            const cupVariantId = parseInt(btn.dataset.cupVariantId, 10);
            const packVariant = cupVariantId
              ? product.variants.find((v) => v.id === cupVariantId)
              : null;
            if (packVariant) {
              qtyInput.value = 1;
              updateUI(packVariant);
            } else {
              qtyInput.value = qty;
              refreshPriceForQty();
            }
            cupBtns.forEach((b) => {
              const isActive = b === btn;
              b.classList.toggle('custom-pdp__cup-btn--active', isActive);
              b.setAttribute('aria-checked', isActive ? 'true' : 'false');
            });

            if (!cupOverlayImg || !firstMediaItem) return;
            const targetSrc = btn.dataset.cupImage || '';
            if (targetSrc) {
              if (cupOverlayImg.src !== targetSrc) cupOverlayImg.src = targetSrc;
              firstMediaItem.classList.add('cup-overlay-visible');
            } else {
              firstMediaItem.classList.remove('cup-overlay-visible');
            }
          });
        });

        // Sync UI on load with the server-rendered default active button
        // (option 2 for products < €100). Defer to next tick so refreshPriceForQty()
        // can read selectedVariant once it's been initialised below.
        const activeCupBtn = section.querySelector('.custom-pdp__cup-btn--active');
        if (activeCupBtn) {
          requestAnimationFrame(() => activeCupBtn.click());
        }
      }
      const sectionId = section.dataset.sectionId || section.id?.replace('shopify-section-', '') || '';
      const product = JSON.parse(
        document.getElementById('custom-pdp-product-json-' + sectionId)?.textContent || 'null'
      );

      if (!product) return;

      // Delivery date calculation by shipping country:
      //   FR            → 1–2 business days
      //   Rest of EU    → 2–3 business days
      //   Rest of world → 7–14 calendar days
      const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

      const EU_COUNTRIES = new Set([
        'AT','BE','BG','HR','CY','CZ','DK','EE','FI','DE','GR','HU','IE','IT',
        'LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
        'GB','CH','NO','IS','LI','AD','MC','SM','VA'
      ]);

      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const dow = result.getDay();
          if (dow !== 0 && dow !== 6) added++;
        }
        return result;
      };

      const addCalendarDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      };

      const formatRange = (arriveMin, arriveMax) => {
        const monthMin = MONTHS[arriveMin.getMonth()];
        const dayMin = arriveMin.getDate();
        const monthMax = MONTHS[arriveMax.getMonth()];
        const dayMax = arriveMax.getDate();
        if (monthMin === monthMax) {
          return monthMin + ' ' + dayMin + '–' + dayMax;
        }
        return monthMin + ' ' + dayMin + '–' + monthMax + ' ' + dayMax;
      };

      const stockEl = section.querySelector('[data-custom-pdp-stock]');
      const country = (stockEl?.dataset.country || '').toUpperCase();

      const getDeliveryRange = () => {
        const now = new Date();
        let arriveMin, arriveMax;
        if (country === 'FR') {
          arriveMin = addBusinessDays(now, 1);
          arriveMax = addBusinessDays(now, 2);
        } else if (EU_COUNTRIES.has(country)) {
          arriveMin = addBusinessDays(now, 2);
          arriveMax = addBusinessDays(now, 3);
        } else {
          arriveMin = addCalendarDays(now, 7);
          arriveMax = addCalendarDays(now, 14);
        }
        return formatRange(arriveMin, arriveMax);
      };

      const deliveryText = 'IN STOCK – ARRIVES ' + getDeliveryRange();

      // Set delivery text on load
      const deliveryEl = section.querySelector('[data-stock-delivery]');
      if (deliveryEl) deliveryEl.textContent = deliveryText;

      const getSelectedOptions = () => {
        const options = [];
        form.querySelectorAll('fieldset[data-option-index]').forEach((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) options.push(checked.value);
        });
        return options;
      };

      const findVariant = (options) => {
        return product.variants.find((v) =>
          v.options.every((opt, i) => opt === options[i])
        );
      };

      // Sticky bar references
      const stickyBar = section.querySelector('[data-sticky-atc]');
      const stickyBtns = stickyBar?.querySelectorAll('[data-sticky-variant-btn]') || [];
      const stickyAtcBtn = stickyBar?.querySelector('[data-sticky-atc-btn]');
      const stickyPrice = stickyBar?.querySelector('[data-sticky-price]');

      const formatPrice = formatPriceSafe;

      const updateUI = (variant) => {
        if (!variant) return;

        selectedVariant = variant;
        variantIdInput.value = variant.id;

        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        const atcText = section.querySelector('[data-atc-text]')?.dataset.atcText || 'ADD TO CART';

        // Update price (main + sticky) — multiplied by current quantity
        refreshPriceForQty();

        // Update fake Klarna installments amount (variant.price / 3, no quantity multiplier)
        const installmentsEl = section.querySelector('[data-installments-monthly]');
        if (installmentsEl) {
          installmentsEl.textContent = formatPriceSafe(Math.floor((variant.price || 0) / 3));
        }

        // Update ATC button (main)
        const atcBtn = form.querySelector('.custom-pdp__atc');
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available ? atcText : 'OUT OF STOCK';
        }
        // Update ATC button (sticky)
        if (stickyAtcBtn) {
          stickyAtcBtn.disabled = !variant.available;
          stickyAtcBtn.textContent = variant.available ? atcText : 'OUT OF STOCK';
        }

        // Update stock status
        const stockEl = section.querySelector('[data-custom-pdp-stock]');
        if (stockEl && variant.inventory_quantity !== undefined) {
          const qty = variant.inventory_quantity;
          let dotColor, textColor, text;
          if (!variant.available) {
            dotColor = '#DC2626';
            textColor = 'red';
            text = 'OUT OF STOCK';
          } else if (qty <= 5 && qty > 0) {
            dotColor = '#D97706';
            textColor = 'yellow';
            text = 'LOW STOCK – ONLY ' + qty + ' LEFT';
          } else {
            dotColor = '#00A63E';
            textColor = 'green';
            text = deliveryText;
          }
          stockEl.innerHTML =
            '<div class="custom-pdp__stock-dot custom-pdp__stock-dot--' + textColor + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="' + dotColor + '"/></svg></div>' +
            '<span class="custom-pdp__stock-text custom-pdp__stock-text--' + textColor + '">' + text + '</span>';
        }

        // Update active button styling (main form)
        radios.forEach((r) => {
          r.closest('.custom-pdp__variant-btn')?.classList.toggle(
            'custom-pdp__variant-btn--active',
            r.checked
          );
        });

        // Update active button styling (sticky)
        stickyBtns.forEach((btn) => {
          const pos = parseInt(btn.dataset.optionPosition, 10);
          btn.classList.toggle('custom-pdp__variant-btn--active', variant.options[pos] === btn.dataset.value);
        });
      };

      // Initialize selectedVariant from current radio state (or fall back to first available variant)
      const initialOptions = getSelectedOptions();
      selectedVariant = findVariant(initialOptions) || product.variants.find((v) => v.available) || product.variants[0];
      // Make sure displayed price respects initial quantity (e.g. cup-options default to 1, qty input default to 1)
      refreshPriceForQty();

      // Main form variant change
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const options = getSelectedOptions();
          const variant = findVariant(options);
          if (variant) updateUI(variant);
        });
      });

      // Sticky variant buttons click -> sync to main form
      stickyBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const pos = parseInt(btn.dataset.optionPosition, 10);
          const val = btn.dataset.value;
          const mainRadio = form.querySelector(
            'fieldset[data-option-index="' + pos + '"] input[value="' + CSS.escape(val) + '"]'
          );
          if (mainRadio) {
            mainRadio.checked = true;
            mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // Sticky ATC button -> submit main form (requestSubmit is reliable even when
      // the submit button is off-screen in a fixed/sticky container)
      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', () => {
          const mainAtc = form.querySelector('.custom-pdp__atc');
          if (mainAtc && mainAtc.disabled) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(mainAtc || undefined);
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
      }

      // Mobile media arrows
      const mediaScroller = section.querySelector('[data-pdp-media]');
      const prevArrow = section.querySelector('[data-pdp-media-prev]');
      const nextArrow = section.querySelector('[data-pdp-media-next]');

      if (mediaScroller && prevArrow && nextArrow) {
        const updateArrows = () => {
          const atStart = mediaScroller.scrollLeft <= 5;
          const atEnd = mediaScroller.scrollLeft >= mediaScroller.scrollWidth - mediaScroller.clientWidth - 5;
          prevArrow.hidden = atStart;
          nextArrow.hidden = atEnd;
        };

        const scrollBy = (dir) => {
          const itemWidth = mediaScroller.querySelector('.custom-pdp__media-item')?.offsetWidth || 0;
          const gap = parseFloat(getComputedStyle(mediaScroller).gap) || 0;
          mediaScroller.scrollBy({ left: dir * (itemWidth + gap), behavior: 'smooth' });
        };

        prevArrow.addEventListener('click', () => scrollBy(-1));
        nextArrow.addEventListener('click', () => scrollBy(1));
        mediaScroller.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      }


      // Show/hide sticky bar based on the main ATC button visibility.
      // Sticky is visible whenever the main ATC is NOT in the viewport
      // (including on initial load when the info column is below the fold).
      if (stickyBar) {
        const mainAtc = form.querySelector('.custom-pdp__atc');
        if (mainAtc) {
          // Default to visible; observer will hide once ATC is in view.
          stickyBar.classList.add('custom-pdp__sticky--visible');
          const observer = new IntersectionObserver(
            ([entry]) => {
              stickyBar.classList.toggle('custom-pdp__sticky--visible', !entry.isIntersecting);
            },
            { threshold: 0.1, rootMargin: '-80px 0px -20px 0px' }
          );
          observer.observe(mainAtc);
        }
      }

      // Shared: add items to cart (sequentially), refresh cart sections, auto-open drawer
      const getCartSectionIds = () => {
        const ids = new Set();
        document.querySelectorAll('cart-items-component').forEach((el) => {
          if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
        });
        return Array.from(ids);
      };

      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const addOneItem = async (item, sectionIds) => {
        const fd = new FormData();
        fd.append('id', item.id);
        fd.append('quantity', item.quantity || 1);
        if (sectionIds && sectionIds.length) {
          fd.append('sections', sectionIds.join(','));
          fd.append('sections_url', window.location.pathname);
        }
        const res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
          credentials: 'same-origin',
        });
        return res.json();
      };

      const fetchCart = async () => {
        const res = await fetch(rootUrl + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        return res.json();
      };

      const addToCartAndOpenDrawer = async (items) => {
        if (!items || !items.length) return;
        try {
          const sectionIds = getCartSectionIds();
          let lastSections = null;
          for (const it of items) {
            const result = await addOneItem(it, sectionIds);
            if (result && (result.status || result.errors)) {
              console.error('Cart add error:', result);
              continue;
            }
            if (result && result.sections) lastSections = result.sections;
          }

          // If cart/add.js didn't return sections (e.g. no sections found or API didn't include them),
          // fetch them fresh via the Sections Rendering API so morphSection runs synchronously
          // and the drawer opens already showing the updated cart.
          if (!lastSections && sectionIds.length) {
            try {
              const sectionUrl = rootUrl + '?sections=' + sectionIds.join(',');
              const sRes = await fetch(sectionUrl, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (sRes.ok) lastSections = await sRes.json();
            } catch (_) {}
          }

          // Fetch plain cart for totals / item_count in the event payload
          const cart = await fetchCart();

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'custom-pdp',
                  itemCount: cart.item_count,
                  sections: lastSections,
                },
              },
            })
          );

          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } catch (e) {
          console.error('Failed to add to cart:', e);
        }
      };

      // Intercept main ATC form submit
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const vid = parseInt(variantIdInput.value, 10);
        if (!vid) return;
        const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
        const atcBtn = form.querySelector('.custom-pdp__atc');
        if (atcBtn) atcBtn.disabled = true;
        addToCartAndOpenDrawer([{ id: vid, quantity: qty }]).finally(() => {
          if (atcBtn) atcBtn.disabled = false;
        });
      });

      // Upsell add to cart
      //  - <€100 (data-upsell-self): goal is to have 2 units of the upsell variant
      //    in the cart. If 0 in cart → add 2; if 1 in cart → add 1; else add 1.
      //  - ≥€100 (cross-sell): add 1 of current PDP variant + 1 of upsell variant.
      const upsellBtn = section.querySelector('[data-upsell-add]');
      if (upsellBtn) {
        upsellBtn.addEventListener('click', async () => {
          const upsellVid = parseInt(upsellBtn.dataset.variantId, 10);
          const mainVid = parseInt(variantIdInput.value, 10);
          const isSelf = upsellBtn.dataset.upsellSelf === 'true';

          let items = [];
          try {
            if (isSelf && upsellVid) {
              const cartRes = await fetch(rootUrl + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
              const cart = await cartRes.json();
              const inCart = (cart.items || []).reduce((sum, it) => (
                it.variant_id === upsellVid ? sum + (it.quantity || 0) : sum
              ), 0);
              const addQty = Math.max(1, 2 - inCart);
              items = [{ id: upsellVid, quantity: addQty }];
            } else {
              if (mainVid) items.push({ id: mainVid, quantity: 1 });
              if (upsellVid && upsellVid !== mainVid) items.push({ id: upsellVid, quantity: 1 });
            }
          } catch (e) {
            console.error('Upsell pre-fetch failed:', e);
            if (upsellVid) items = [{ id: upsellVid, quantity: 1 }];
          }

          upsellBtn.disabled = true;
          await addToCartAndOpenDrawer(items);
          upsellBtn.disabled = false;
        });
      }
    };

    const boot = () => {
      document.querySelectorAll('[data-custom-pdp-info]').forEach((el) => {
        const sec = el.closest('.shopify-section');
        if (sec && !sec.dataset.pdpInit) {
          sec.dataset.pdpInit = 'true';
          initCustomPDP(sec);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (e) => {
      initCustomPDP(e.target);
    });

    // Scroll-reveal animations
    const initAnimations = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('pdp-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      document.querySelectorAll('.pdp-reveal').forEach((el) => observer.observe(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnimations);
    } else {
      initAnimations();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-description-split"]) return;
  try {
    
  (function () {
    const containers = document.querySelectorAll('[data-pdp-split-text]');
    if (!containers.length) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    containers.forEach((container) => {
      if (prefersReduced) {
        container.classList.add('is-visible');
        return;
      }

      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim()) textNodes.push(node);
      }

      let wordIndex = 0;
      textNodes.forEach((textNode) => {
        const frag = document.createDocumentFragment();
        const parts = textNode.nodeValue.split(/(\s+)/);
        parts.forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement('span');
            span.className = 'pdp-split__word';
            span.style.setProperty('--w-delay', wordIndex * 35 + 'ms');
            span.textContent = part;
            frag.appendChild(span);
            wordIndex++;
          }
        });
        textNode.parentNode.replaceChild(frag, textNode);
      });
    });

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    containers.forEach((c) => obs.observe(c));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-manufacture"]) return;
  try {
    
  const mfgObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('pdp-mfg--visible');
        mfgObs.unobserve(e.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -30px 0px'
  });
  document.querySelectorAll('.pdp-mfg__reveal').forEach((el) => mfgObs.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-hero-counter"] && !Shopify.designMode) return;
  try {
    
  const statsCounterSections = document.querySelectorAll('.stats-hero-counter');

  function decimalPlaces(value) {
    const stringValue = String(value);

    if (! stringValue.includes('.')) {
      return 0;
    }

    return stringValue.split('.')[1].length;
  }

  function formatCounterValue(value, decimals) {
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function animateCounter(counterElement) {
    if (counterElement.dataset.counterAnimated === 'true') {
      return;
    }

    const numberElement = counterElement.querySelector('[data-counter-number]');

    if (! numberElement) {
      return;
    }

    const end = Number(counterElement.dataset.counterEnd || 0);
    const duration = Math.max(300, Number(counterElement.dataset.counterDuration || 1600));
    const decimals = decimalPlaces(end);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    counterElement.dataset.counterAnimated = 'true';

    if (Number.isNaN(end)) {
      numberElement.textContent = '0';
      return;
    }

    if (reducedMotion || end === 0) {
      numberElement.textContent = formatCounterValue(end, decimals);
      return;
    }

    const startTime = performance.now();

    const tick = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = end * eased;

      numberElement.textContent = formatCounterValue(value, decimals);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
        return;
      }

      numberElement.textContent = formatCounterValue(end, decimals);
    };

    window.requestAnimationFrame(tick);
  }

  function initStatsCounterSection(sectionElement) {
    if (! sectionElement || sectionElement.dataset.counterSectionInitialized === 'true') {
      return;
    }

    const counters = sectionElement.querySelectorAll('[data-counter]');

    if (! counters.length) {
      sectionElement.dataset.counterSectionInitialized = 'true';
      return;
    }

    sectionElement.dataset.counterSectionInitialized = 'true';

    if (!('IntersectionObserver' in window)) {
      counters.forEach((counter) => animateCounter(counter));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      threshold: 0.35
    });

    counters.forEach((counter) => observer.observe(counter));
  }

  statsCounterSections.forEach((sectionElement) => initStatsCounterSection(sectionElement));

  document.addEventListener('shopify:section:load', (event) => {
    const sectionElement = event.target.querySelector('.stats-hero-counter');
    initStatsCounterSection(sectionElement);
  });

  } catch(e) { console.error(e); }
})();
})();
